export const styles = {
  container: {
    marginLeft: '12px',
    background: '#4D6EF5',
    fontFamily: 'Inter',
    color: '#EDEEF1',
    fontSize: '14px',
    fontWeight: 400,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
  },
};
